import { sortBy } from "lodash";
import { DegreeType, UnitRenderMode } from "../../util/enum";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Badge } from "ant-design-vue";
import { UnitObjectiveModel } from "@/services/objective-manager";
import { VCSLevelModel } from "@/models/title-list-model";

@Component({
	components: {
		Badge
	}
})
export default class UnitObjectiveCheckView extends Vue {
	@Prop({ default: [] }) unitObjectives!: UnitObjectiveModel[];
	@Prop({ default: [] }) vcsLevelUnits!: VCSLevelModel[];
	@Prop({ default: {} as any }) unitObject;
	public UnitRenderMode = UnitRenderMode;

	get startUnit() {
		const unitObject = this.vcsLevelUnits.find((vl) => vl.id == this.unitObject.startUnitId);
		return unitObject ? unitObject.unit : this.unitObject.startUnitId;
	}

	get endUnit() {
		const unitObject = this.vcsLevelUnits.find((vl) => vl.id == this.unitObject.endUnitId);
		return unitObject ? unitObject.unit : this.unitObject.endUnitId;
	}

	get formatUnitObjectivesWithUnit() {
		return this.unitObjectives.map((u) => {
			const unitObject = this.vcsLevelUnits.find((vl) => vl.id == u.unitId);
			return {
				...u,
				unit: unitObject ? unitObject.unit : u.unitId
			};
		});
	}

	get Units(): UnitObjectiveModel[] {
		return sortBy(this.formatUnitObjectivesWithUnit, "unit").filter(
			(u) => u.unit >= this.startUnit && u.unit <= this.endUnit
		);
	}

	get firstUnit(): UnitObjectiveModel {
		return this.Units[0];
	}

	get lastUnit(): UnitObjectiveModel {
		return this.Units[this.Units.length - 1];
	}

	get unitRange(): number[] {
		const unitRange: number[] = [];
		for (var i = 0; i < this.endUnit - this.startUnit + 1; i++) {
			unitRange.push(this.startUnit + i);
		}
		return unitRange;
	}

	getRenderMode(item: number): UnitRenderMode {
		if (!this.Units.length) {
			return UnitRenderMode.None;
		}
		const index: number = this.Units.findIndex((u) => u.unit === item);
		switch (true) {
			case (index < 0 && (item < this.firstUnit.unit! || item > this.lastUnit.unit!)) ||
				(index < 0 && item > this.firstUnit.unit! && item < this.lastUnit.unit!):
				return UnitRenderMode.None;
			case index >= 0 || index === this.Units.length - 1:
				return UnitRenderMode.Circle;
			default:
				return UnitRenderMode.None;
		}
	}

	// getUnitDegreeColor(item: number): string {
	// 	const unit: UnitObjectiveModel | undefined = this.Units.find((u) => u.unit === item);
	// 	switch (unit && unit.degree) {
	// 		case DegreeType.Basic:
	// 			return "basic";
	// 		case DegreeType.Intermediate:
	// 			return "Intermediate";
	// 		case DegreeType.Expert:
	// 			return "expert";
	// 		default:
	// 			return "basic";
	// 	}
	// }
}
